<template>
  <div v-if="showPaginator" class="paginator" :class="baseClassModifier">
    <div v-if="!noSummary" class="paginator__end-fake-block" />
    <div v-if="!noSummary" class="paginator__summary-label">
      {{
        $t('general.grid-legend', {
          firstItemOrderNumber: firstItemOrderNumber,
          lastItemOrderNumber: lastItemOrderNumber,
          total: totalRows,
        })
      }}
    </div>

    <b-pagination
      :total-rows="totalRows"
      :per-page="perPage"
      @input="inputPageChange"
      :value="currentPage"
      :limit="limit"
      align="end"
      class="paginator__pagination"
    >
      <i
        aria-hidden="true"
        class="fas fa-angle-double-left fa-lg"
        slot="first-text"
      />
      <div slot="prev-text">
        <i aria-hidden="true" class="fas fa-angle-left fa-lg" />
        <span class="paginator__button-text">
          {{ $t('general.previous') }}
        </span>
      </div>
      <div slot="next-text">
        <span class="paginator__button-text">
          {{ $t('general.next') }}
        </span>
        <i aria-hidden="true" class="fas fa-angle-right fa-lg" />
      </div>
      <i
        aria-hidden="true"
        class="fas fa-angle-double-right fa-lg"
        slot="last-text"
      />
      <template v-if="$scopedSlots.page" v-slot:page="scope">
        <slot name="page" v-bind="scope" />
      </template>
    </b-pagination>
  </div>
</template>
<style lang="sass" scoped>
@import src/styles/defaults/variables
@import src/styles/defaults/mobile-first

.paginator
  width: 100%
  display: flex
  align-items: center
  flex-wrap: wrap
  flex-direction: row
  justify-content: flex-end
  +media-max-md()
    justify-content: center
  ::v-deep .page-item
    white-space: nowrap
  .paginator
    &__summary-label
      text-align: center
      white-space: nowrap
      margin-bottom: 14px
      padding-left: 10px
    &__pagination
      justify-self: center
      ::v-deep .page-item
        white-space: nowrap
    +media-max-sm
      &__end-fake-block
        display: none
    &__button-text
      display: none
  &_size-normal
    +media-min-lg()
      flex-direction: row
    .paginator
      +media-min-sm()
        &__button-text
          display: initial
          font-size: 0.95rem
      +media-min-md()
        &__button-text
          font-size: 1rem
      +media-min-lg()
        &__summary-label
          text-align: right
          margin-right: 2rem
      +media-min-xl()
        &__end-fake-block
          display: block
  &_size-normal-side-menu
    +media-min-2xl()
      flex-direction: row
    .paginator
      +media-min-xl()
        &__button-text
          display: initial
          font-size: 0.95rem
      +media-min-xl()
        &__button-text
          font-size: 1rem
      +media-min-2xl()
        &__summary-label
          text-align: left
      +media-min-3xl()
        &__end-fake-block
          display: block
  &_size-small
    +media-3xl()
      justify-content: flex-end
    +media-min-3xl()
      flex-direction: row
    .paginator
      +media-max-lg()
        &__pagination
          ::v-deep .page-item
            display: none
          ::v-deep .page-item.active,
          ::v-deep .page-item:nth-child(1),
          ::v-deep .page-item:nth-child(2),
          ::v-deep .page-item:nth-last-child(2),
          ::v-deep .page-item:nth-last-child(1)
            display: list-item
      +media-3xl()
        &__pagination
          flex: unset
          margin-right: 30px
      +media-min-3xl()
        &__summary-label
          text-align: left
        &__button-text
          display: initial
          font-size: 1rem
      +media-min-4xl()
        &__end-fake-block
          display: block
</style>

<script>
import { mapGetters } from 'vuex';

export default {
  components: {},
  props: {
    value: {
      type: Number,
      default: 1,
    },
    limit: {
      type: Number,
      default: 9,
    },
    perPage: {
      type: Number,
      default: 10,
    },
    totalRows: {
      type: Number,
    },
    noSummary: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'normal',
    },
  },
  methods: {
    inputPageChange($event) {
      this.$emit('input', $event);
    },
  },
  computed: {
    ...mapGetters(['currentFontSize']),
    showPaginator() {
      return this.totalRows && this.totalRows > 0;
    },
    currentPage() {
      return this.value;
    },
    firstItemOrderNumber() {
      return (this.currentPage - 1) * this.perPage + 1;
    },
    lastItemOrderNumber() {
      let last = this.currentPage * this.perPage;
      if (last > this.totalRows) {
        last = this.totalRows;
      }
      return last;
    },
    baseClassModifier() {
      return `paginator_size-${this.size}`;
    },
  },
};
</script>
